import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useRouteError } from 'react-router-dom';
export function RemoteRouteErrorElement({ route }) {
    const error = useRouteError();
    throw new Error(error.stack, { cause: route });
    return _jsx(_Fragment, {});
}
